module.exports = __webpack_public_path__ + "media/images/icons/smp_payment_behavior-d1c8919f7a2d56d906171ea09470f73f.svg";